import Meisterkachel from './Meisterkachel';
import React from 'react';

function MeisterkachelAndRelatedCategories() {
    return (
        <section className="uk-section uk-section-muted uk-section-small uk-padding">
                <div className="uk-container uk-container-xsmall">
                    <Meisterkachel />
                </div>
            </section>
    );
}

export default MeisterkachelAndRelatedCategories;
